// Midas will bring separate line items for subscriptions, discounts, etc.
// This is the code that identifies a subscription.
export const NOVA_WAREHOUSE_SUBSCRIPTION_PRODUCT_CODE = 'NV13-WH';
